import { Component, OnInit } from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import {CommonUtil} from '../../../../utils/common.util';
import {AdminService} from '../../../../shared/admin.services';
import {UrlConstants} from '../../../../shared/url.constant';

@Component({
  selector: 'app-staff-sidebar',
  templateUrl: './staff-sidebar.component.html',
  styleUrls: ['./staff-sidebar.scss']
})
export class StaffSidebarComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();

  public userName = '';
  public userData;
  public placeholderPath = '../../../../../assets/images/profile-image.png';
  public imageUrl = this.placeholderPath;
  displayMessage: string;
  showAlertSuccess = false;
  showAlertFailure = false;

  constructor(private adminService: AdminService) {

    // const staffData = JSON.parse(localStorage['userProfile']);
    // const staffId = staffData.staff_id;
    // this.getStaffById(staffId);

    // this.userData = JSON.parse(localStorage['userProfile']);
  }

  getStaffById(staffId): void {
    const pathParams = staffId;
    const url = UrlConstants.teachingStaff + '/' + pathParams;
    this.adminService.getStaffById({url: url, params: ''}).then(res => {
      if (res.success === true) {
        this.userData = res.data;
        this.getStaffProfileImage();
      }
    }).catch((error) => {

      console.log(error);
    });
  }


  getStaffProfileImage() {
    if (this.userData !== undefined && this.userData.photo !== undefined) {
      console.log(this.userData);
      const isThumbnail = false;
      const queryParams = '?thumbnail=' + isThumbnail + '&image=';
      this.adminService.getImage({ url: UrlConstants.getImage + queryParams + this.userData.photo, params: '' }).then(res => {
      }).catch((error: any) => {
        this.imageUrl = this.imageUrl = UrlConstants.getImage + '?thumbnail=' + isThumbnail + '&image=' + this.userData.photo;
        console.log(error);
        if (error.success === false) {
          console.log('Error Status >> ', error.success);
          this.imageUrl = '../../../../../assets/images/profile-image.png';
        }
      });
    } else {
      this.imageUrl = '../../../../../assets/images/profile-image.png';
    }
  }

  ngOnInit() {
    const token = localStorage.getItem('userToken');
    if (token !== null) {
      const userData = jwt_decode(token);
      const name = userData.name;

      console.log('userData ', name.replace(null, ''));

      this.userName = '';
      this.userName = name.replace(null, '');

      console.log('userData ###', userData);
      this.getStaffById(userData.user_id);
    }
    // active class remove class
    (<any>$('.side-menu-root > a').click(function() {
      (<any>$('.side-menu-root.active')).removeClass('active');
      (<any>$(this).closest('li')).addClass('active');
    }));
  }

}
